import React, { Component } from 'react'

export default class Newsletter extends Component {
    render() {
        return (
            
            <div> <div class="">
                 <main id="main">
                <section id="why-us" class="wow fadeIn"> 
                <div class="row counters">
    
    <div class="col-lg-3 col-6 text-center">
      <span data-toggle="counter-up">274</span>
      <p>Clients</p>
    </div>

    <div class="col-lg-3 col-6 text-center">
      <span data-toggle="counter-up">421</span>
      <p>Projects</p>
    </div>

    <div class="col-lg-3 col-6 text-center">
      <span data-toggle="counter-up">1,364</span>
      <p>Hours Of Support</p>
    </div>

    <div class="col-lg-3 col-6 text-center">
      <span data-toggle="counter-up">18</span>
      <p>Hard Workers</p>
    </div>


  </div>
                 </section>
     <section id="call-to-action" class="wow fadeInUp">
      <div class="container">
        <div class="row">
          <div class="col-lg-9 text-center text-lg-left">
            <h3 class="cta-title">Call To Action</h3>
            <p class="cta-text"> Your time is limited, so don't waste it living someone else's life, Start now , Start Today.</p>
          </div>
          <div class="col-lg-3 cta-btn-container text-center">
            <a class="cta-btn align-middle" href="#">Call To Action</a>
          </div>
        </div>

      </div>
    </section>
                 </main>
           
    
          </div>
        
    
            </div>
        )
    }
}
